export enum ITabsEnum {
  LOCAL = 'LOCAL',
  TOLL_FREE = 'TOLL_FREE',
}
